import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0086 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="長時間労働の影響と対策について。過重労働を防ぐための具体例を解説" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.11.27</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        日本の雇用慣行上、特に非正規社員よりも正社員の方が長時間労働の傾向があり、また、長時間労働は本人だけでなく、周囲の労働者を巻き添えにしてしまうこともあります。そして、過重労働という言葉があるように、労働はある一定ラインを超えると「働き甲斐」どころか心身を蝕むこともあります。今回は長時間労働などの過重労働を防ぐためにできることに注視し、解説します。
      </p>
      <img src="/images/column/details/c0086.jpg" alt="キンクラコラム画像86" />
      <div id="toc1">
        <h1>過重労働とは</h1>
      </div>
      <p>
        <span>本人の力量等を超えて過大な業務</span>
        （業務の難易度が著しく高いことや業務量が著しく多い等）が課せられており、かつ、その状態が慢性的となっているケースが挙げられます。過重労働とは
        <span>
          法律用語ではないため、休憩や休日あるいは有給休暇が取れないことを指すケース
        </span>
        も考えられます。過重労働は労働者の健康を蝕むだけでなく、創造性の低下や他の労働者の「お付き合い残業」を誘発する等の負の側面が指摘されており、何らかの対策が望まれます。
      </p>

      <div id="toc2">
        <h1>過重労働を防ぐには</h1>
      </div>
      <p>
        まずは
        <span>適正な人員配置と業務分担が必要 </span>
        となります。すなわち、通常の賃金については減額されることはありませんが、残業代の算定にあたっての労働時間の通算はおこなわないこととなります。
        です。もちろん、我が国の99%を占める中小企業においては配属先で「自分の仕事しかしない」という考え方は適切でなく、隣接する部署や欠員時の補充として代替的な業務を担うことは珍しいことではありません。しかし、その状態が慢性的に続いてしまうと過重労働状態に陥ることもあります。よって、そのようなイレギュラーな体制を敷く場合には
        <span>
          期限を決めておくことで過重労働状態に陥ることを防ぐことが可能となります
        </span>
        。ただし、人手不足感が際立つ現在において、一度決めた期限を超えてしまうことは珍しいことではありません。万が一、そのような事態となった場合は、適宜、
        <span>上長と当該労働者間で面談の実施</span>
        を行うことです。面談の中で上長が労働者の言動等に
        <span>
          違和感を覚えた際には会社の安全配慮義務として一定の措置を講ずることが求められます
        </span>
        （具体的には一定の休息を与える等）。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>リスクを軽減する勤怠管理のポイントとは</h1>
      </div>
      <p>
        <span>遅刻早退が増えている労働者の抽出が挙げられます</span>
        。シフト制の勤務やフレックスタイム制は制度としては存在するものの、日本の多くの企業では固定労働時間制が採用されています。必然的に毎日決まった時間に出社することが半ば強制されていると言えます。
        <span>
          そのような状況下で定期的に遅刻をしている状況は普通とは言えず、それは、本人が醸し出す何らかのサイン
        </span>
        （例えば過重労働が間接的な原因となり病気に罹患した）かもしれません。有給休暇の時間単位請求を認めていない場合、月給者は、原則として欠勤控除の対象となるにも関わらず、そのような状態が続いているということは本人の経済事情としてもマイナスであることは想像に難くありません。また、早退についても遅刻と同様の可能性がありますが、家族の介護のためや、本人以外の外部的な要因が絡んでいることもありますので、プライバシーに配慮をしながらも確認をしておくことが無難です。
        <br />
        <br />
        次に慢性的な長時間労働者です。長時間労働は過労死にも直結することがあり、一時は社会的な問題にも発展しました。当然36協定の限度内での労働であっても長期間反復継続して行われるとなれば消耗するのが自然です。また、残業自体が常態化していると、もはや終業時刻を過ぎてから「業務を開始」するような錯覚に陥っていることがあります。
        <span>
          対応策としては、制度として、半ば強制的に特定の日は残業ができない日（仮称
          ノー残業デー等）を設定すること
        </span>
        が考えられます。あわせて、残業の事前承認制が挙げられます。その月の末にようやく上長が残業時間を把握するような形では既に長時間労働に陥ってしまった後に知ることとなります。それでは当然遅いため、事前に回避するためには日々の時間外労働からある程度把握する運用にすべきです。もちろん、緊急時には事後的な報告になってしまうことも想定されますが、原則としては事前承認制とすることで、ある程度の部分までは時間外労働の推移を把握することが可能となります。
        <br />
        <br />
        期限の設定についても留意が必要です。業務である以上、期限のない業務は業務とは呼べませんが、
        <span>著しく短期間での設定は長時間労働への誘引となります</span>
        。これは特に職位が上位の者から下位の者へ指揮命令が行われる場合に多く、あまりにも短期間での設定は、特に有能な労働者ほど無理をして間に合わせようとする傾向にあり、過重労働となってしまうことがあります。言うまでもなく、期限の設定は絶対的に必要であるものの、ある程度逆算し、早めに指示を出すという工夫や配慮は必要不可欠です。
      </p>

      <div id="toc4">
        <h1>最後に</h1>
      </div>
      <p>
        長時間労働は本人が自主的に気づくことは難しく、周囲が指摘してあげることでようやく異変に気付くというケースが一般的です。近年は各種ITツールが発達し、どのような働き方をしているのかをリアルに把握することが容易になっています。各種ITツールを活用し、心身を蝕む長時間労働を抑止することが企業の生産性向上にも寄与することとなります。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0086
